/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon, Image, Label } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

const Courier = ({courier}) => {
    const [t] = useTranslation()
    const [imageError, setImageError] = useState(false)

    return (
      <div>
          <div css={css`
              display: flex;
              align-items: center;
              gap: 1rem;
          `}>
              <div>
                  {courier.pictureUrl && !imageError ? (
                    <Image
                      src={courier.pictureUrl}
                      circular
                      size="tiny"
                      onError={() => {
                          setImageError(true)
                      }}
                      css={css`
                          &.ui.tiny.image {
                              width: 50px;
                              height: 50px;
                              object-fit: cover;
                          }
                      `}
                    />
                  ) : (
                    <div css={css`
                        width: 50px;
                        height: 50px;
                        background-color: white;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    `}>
                        <Icon name="user" size="large" color="grey"/>
                    </div>
                  )}
              </div>

              <div css={css`
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
              `}>
                  <div css={css`
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      margin-bottom: 4px;
                  `}>
                      <div css={css`
                          font-weight: bold;
                          font-size: 1rem;
                      `}>
                          {courier?.name}
                      </div>
                      <Label
                        size="tiny"
                        color='teal'
                        basic
                        css={css`
                            &.ui.tiny.label {
                                padding: 0.5em 0.8em;
                            }
                        `}
                      >
                          {t(`order.delivery.${courier.status}`)}
                      </Label>
                  </div>

                  {courier?.phone && (
                    <div css={css`
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        color: grey;
                        font-size: 0.9rem;
                    `}>
                        <Icon name="phone" size="small"/>
                        {courier?.phone && (<span>{courier.phone} ({courier.phoneCode})</span>)}
                    </div>
                  )}
              </div>
          </div>
      </div>
    )
}

export { Courier }
